import React from 'react'
import Layout from '../../../components/corporateAdmin/Layout'
import { Helmet } from 'react-helmet'
import Chart from '../../../components/ui/demo/Chart'

function NoUsage() {
    return (
        <div>
            <Layout>
                <Helmet>
                    <title>Admin - No of Usage </title>
                </Helmet>
                <Chart title="No of App Users" />

            </Layout>
        </div>
    )
}

export default NoUsage
